import React from 'react';
import { Phone, Printer, Mail, Users } from 'lucide-react';

const DirectoryPage = () => {
  const directoryData = [
    {
      name: "Greg Scott",
      email: "greg.scott@thescottbusinessgroup.com",
      role: "CEO"
    },
    {
      name: "Millie Gonzalez-Scott",
      email: "mg.scott@thescottbusinessgroup.com",
      role: "COO"
    },
    {
      name: "Liz Camacho",
      email: "liz@thescottbusinessgroup.com",
      role: "HR Manager"
    },
    {
      name: "Agatha Rijo",
      email: "agatha@thescottbusinessgroup.com",
      role: "Staff"
    },
    {
      name: "Annise Scott",
      email: "ascott@scottbiz.net",
      role: "Staff"
    }
  ];

  return (
    <div className="min-h-screen bg-green-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden border-b-4 border-orange-500">
          <div className="px-6 py-5 border-b border-gray-200">
            <div className="flex items-center">
              <div className="bg-orange-100 p-2 rounded-full mr-3">
                <Users className="h-5 w-5 text-green-600" />
              </div>
              <h1 className="text-2xl font-semibold text-green-800">Company Directory</h1>
            </div>
          </div>
          
          <div className="px-6 py-4 border-b border-gray-200 bg-green-50">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center space-y-2 sm:space-y-0">
              <div className="flex items-center">
                <div className="bg-orange-100 p-1.5 rounded-full mr-2">
                  <Phone className="h-4 w-4 text-green-600" />
                </div>
                <span className="text-gray-700">602-400-8028</span>
              </div>
              <div className="flex items-center">
                <div className="bg-orange-100 p-1.5 rounded-full mr-2">
                  <Printer className="h-4 w-4 text-green-600" />
                </div>
                <span className="text-gray-700">623-321-1327</span>
              </div>
            </div>
          </div>

          <div className="divide-y divide-gray-200">
            {directoryData.map((contact, index) => (
              <div key={index} className="px-6 py-4 hover:bg-orange-50 transition-colors duration-200">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                  <div>
                    <h3 className="text-lg font-medium text-green-800">{contact.name}</h3>
                    {contact.role && (
                      <p className="text-sm text-gray-600">{contact.role}</p>
                    )}
                  </div>
                  <div className="mt-2 sm:mt-0">
                    <a
                      href={`mailto:${contact.email}`}
                      className="flex items-center text-orange-500 hover:text-orange-600"
                    >
                      <div className="bg-orange-100 p-1 rounded-full mr-1">
                        <Mail className="h-3 w-3 text-green-600" />
                      </div>
                      <span className="text-sm">{contact.email}</span>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DirectoryPage; 